export const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    add: "Add",
    search: "Search",
    filter: "Filter",
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    back: "Back",
    next: "Next",
    confirm: "Confirm",
    close: "Close",
    yes: "Yes",
    no: "No",
    active: "Active",
    inactive: "Inactive",
    required: "Required",
    optional: "Optional",
    noResults: "No results found",
    addressSearchFailed: "Address search is unavailable right now. Please try again later.",
    actions: "Actions",
    details: "Details",
    status: "Status",
    total: "Total",
    items: "Items",
    submit: "Submit",
    upload: "Upload",
    remove: "Remove",
    poweredBy: "Powered by Level App",
  },
  offline: {
    banner: "No internet connection — some actions are unavailable",
    actionDisabled: "Requires internet connection",
  },
  auth: {
    login: "Log In",
    register: "Register",
    logout: "Log Out",
    phone: "Phone Number",
    phoneHint: "Enter your phone number",
    otp: "Verification Code",
    otpHint: "Enter the code sent to your phone",
    sendOtp: "Send Code",
    resendOtp: "Resend Code",
    verify: "Verify",
    createAccount: "Create Business Account",
    welcomeBack: "Welcome Back",
    welcomeTitle: "BiDi for Business",
    welcomeSubtitle: "Manage your business with ease",
    sessionExpired: "Session expired, please log in again",
    fullName: "Full Name",
    email: "Email",
    password: "Password",
    businessName: "Business Name",
    address: "Address",
    businessRegistrationNumber: "Business Registration Number",
    alreadyHaveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    resendIn: "Resend in {{seconds}} seconds",
    noBusinessAccount:
      "No business account is linked to this phone number. Enter the business owner's phone number.",
  },
  nav: {
    dashboard: "Dashboard",
    orders: "Orders",
    orderHistory: "Order History",
    reviews: "Reviews",
    menu: "Menu",
    profile: "Business Profile",
    cityConfigs: "City Configs",
    settings: "Settings",
    collapseSidebar: "Collapse",
    expandSidebar: "Expand",
  },
  reviews: {
    title: "Reviews",
    empty: "No reviews yet",
    emptyDescription: "Reviews from customers will appear here",
    anonymous: "Customer",
  },
  cityConfigs: {
    title: "Minimum Order per City",
    description: "Set the minimum order amount for each city you deliver to",
    addCity: "Add City",
    city: "City",
    selectCity: "Select a city",
    minimumOrder: "Minimum Order",
    deliveryFee: "Delivery Fee",
    saved: "Saved successfully",
    deleted: "Deleted successfully",
  },
  dashboard: {
    title: "Dashboard",
    newOrders: "New Orders",
    activeOrders: "Active Orders",
    todayOrders: "Today's Orders",
    operationStatus: "Operation Status",
    regular: "Open",
    manuallyClosed: "Manually Closed",
    pausedOrders: "Orders Paused",
    preparationTime: "Preparation Time (min)",
    updatePrepTime: "Update",
    quickActions: "Quick Actions",
    viewAllOrders: "View All Orders",
    editMenu: "Edit Menu",
    editProfile: "Edit Profile",
    stats: {
      title: "Statistics",
      subtitle: "Based on orders in Delivered status for the selected period",
      topDishes: "Top selling items (up to 5)",
      topAreas: "Top areas (up to 5)",
      quantityValue: "{{count}} units",
      ordersValue: "{{count}} orders",
      pickupArea: "Pickup",
      unknownCity: "City not specified",
      empty: "No data for this period",
    },
  },
  orders: {
    title: "Orders",
    empty: "No orders yet",
    emptyDescription: "New orders will appear here",
    emptyColumn: "No orders",
    searchPlaceholder: "Search by order number...",
    columns: {
      inPreparation: "In Preparation",
      readyForPickup: "Ready for Pickup",
    },
    orderNumber: "Order #{{number}}",
    new: "New",
    accepted: "Accepted",
    inPreparation: "In Preparation",
    readyForPickup: "Ready for Pickup",
    courierAssigned: "Courier Assigned",
    pickedUp: "Picked Up",
    delivered: "Delivered",
    cancelled: "Cancelled",
    accept: "Accept Order",
    reject: "Reject Order",
    startPreparation: "Start Preparation",
    markReady: "Mark as Ready",
    markDelivered: "Mark as Delivered",
    cancelOrder: "Cancel Order",
    confirmCancel: "Are you sure you want to cancel this order?",
    creditCustomer: "Credit customer",
    creditDescription: "Enter a credit amount to register for the customer in the context of this order.",
    creditAmountLabel: "Credit amount (₪)",
    confirmCredit: "Confirm credit",
    creditAmountInvalid: "Enter a positive credit amount",
    creditSuccess: "Credit recorded successfully",
    subtotal: "Subtotal",
    deliveryFee: "Delivery Fee",
    totalAmount: "Total",
    paymentMethod: "Payment Method",
    creditCard: "Credit Card",
    cash: "Cash",
    notes: "Notes",
    noNotes: "No notes",
    customer: "Customer",
    customerPhone: "Customer Phone",
    orderType: "Order Type",
    deliveryAddress: "Delivery Address",
    delivery: "Delivery",
    pickup: "Pickup",
    statusTimeline: "Status Timeline",
    courierInfo: "Courier Info",
    courierName: "Courier Name",
    courierPhone: "Courier Phone",
    estimatedPickup: "Estimated Pickup",
    customerReview: "Customer review",
    reviewRating: "Rating",
    noReviewYet: "No review yet",
    history: "History",
    historyTitle: "Order History",
    historyEmpty: "No orders in history",
    historyEmptyDescription: "Completed or cancelled orders will appear here",
    dateRange: {
      label: "Date Range",
      thisWeek: "This Week",
      lastWeek: "Last Week",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      custom: "Custom",
      from: "From",
      to: "To",
    },
    date: "Date",
    itemCount: "{{count}} items",
    showDetails: "Show Order Details",
    newOrderTitle: "New Order Received!",
    newOrderDescription: "Choose whether to accept or cancel this order",
    moreNewOrders: "and {{count}} more new orders waiting",
  },
  menu: {
    title: "Menu",
    categoriesTitle: "Categories",
    itemsTitle: "Menu Items",
    addCategory: "Add Category",
    addItem: "Add Item",
    editCategory: "Edit Category",
    editItem: "Edit Item",
    newCategory: "New Category",
    newItem: "New Item",
    categoryName: "Category Name",
    itemName: "Item Name",
    description: "Description",
    price: "Price",
    image: "Image",
    tags: "Tags",
    selectTags: "Select tags",
    noTagsAvailable: "No tags available",
    optionsGroups: "Options Groups",
    menuItemOptions: "Options",
    addOptionsGroup: "Add Options Group",
    addMenuItemOption: "Add Option",
    optionsGroupName: "Group Name",
    optionName: "Option Name",
    minSelections: "Min Selections",
    maxSelections: "Max Selections",
    sortOrder: "Sort Order",
    reorder: "Reorder",
    noCategories: "No categories yet",
    noCategoriesDescription: "Add your first category",
    noItems: "No items in this category",
    noItemsDescription: "Add your first item",
    deleteCategory: "Delete Category",
    deleteItem: "Delete Item",
    confirmDeleteCategory: "Are you sure you want to delete this category?",
    confirmDeleteItem: "Are you sure you want to delete this item?",
    hebrewTab: "Hebrew",
    englishTab: "English",
    arabicTab: "Arabic",
    russianTab: "Russian",
    editOptionsGroup: "Edit Options Group",
    editMenuItemOption: "Edit Option",
    deleteOptionsGroup: "Delete Options Group",
    deleteMenuItemOption: "Delete Option",
    confirmDeleteOptionsGroup:
      "Are you sure you want to delete this options group and all its options?",
    confirmDeleteMenuItemOption:
      "Are you sure you want to delete this option?",
    noOptionsGroups: "No options groups yet",
    noOptionsGroupsDescription: "Add options groups to let customers customize this item",
    noOptions: "No options in this group yet",
    optionPrice: "Additional Price",
    saveItemFirst: "Save the item first to manage options groups",
    reorderError: "Failed to save the new order",
    dragToReorder: "Drag to reorder",
    toggleActiveError: "Failed to update status",
    allowDuplicateSelections: "Allow selecting the same option multiple times",
    deactivateTitle: "Deactivate",
    deactivateDescription: "Choose how long to deactivate for",
    deactivateIndefinite: "Indefinitely",
    deactivateTimed: "For a specific duration",
    deactivateHours: "Hours",
    deactivateConfirm: "Deactivate",
    deactivateCancel: "Cancel",
  },
  profile: {
    title: "Business Profile",
    businessInfo: "Business Information",
    contactInfo: "Contact Information",
    deliverySettings: "Delivery Settings",
    bankDetails: "Bank Details",
    workingHoursTitle: "Working Hours",
    name: "Business Name",
    description: "Description",
    logo: "Logo",
    coverImage: "Cover Image",
    phone: "Phone",
    email: "Email",
    contactType: "Contact Channel",
    contactTypeNone: "Not specified",
    contactTypeWhatsapp: "WhatsApp",
    contactTypePhone: "Phone",
    contactTypeEmail: "Email",
    contactValuePhone: "Phone Number",
    contactValueEmail: "Email Address",
    contactInvalidEmail: "Invalid email address",
    contactInvalidPhone: "Invalid Israeli phone number",
    address: "Address",
    registrationNumber: "Business Registration Number",
    kosherStatus: "Kosher Status",
    kosher: "Kosher",
    kosherLeMehadrin: "Kosher Le'Mehadrin",
    badatz: "Badatz",
    mehadrinMinHaMehadrin: "Mehadrin Min HaMehadrin",
    rabbanut: "Rabbanut",
    rabbanutMehadrin: "Rabbanut Mehadrin",
    notKosher: "Not Kosher",
    none: "Not Specified",
    estimatedPreparationTime: "Estimated Preparation Time (min)",
    businessPhone: "Business Phone",
    ownerPhone: "Owner Phone",
    minimumOrder: "Minimum Order Amount",
    acceptsCash: "Accepts Cash",
    bankHolderName: "Account Holder Name",
    bankNumber: "Bank Number",
    branchNumber: "Branch Number",
    accountNumber: "Account Number",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    openTime: "Open",
    closeTime: "Close",
    closed: "Closed",
    addHours: "Add Hours",
  },
  settings: {
    title: "Settings",
    language: "Language",
    notifications: "Notifications",
    enableNotifications: "Enable Notifications",
    notificationsDescription: "Receive notifications for new orders",
    about: "About",
    version: "Version",
    hebrew: "עברית",
    english: "English",
    russian: "Русский",
    arabic: "العربية",
  },
  approval: {
    pendingTitle: "Pending Approval",
    pendingDescription:
      "Your business account is pending admin approval. We'll notify you once approved.",
    blockedTitle: "Account Blocked",
    blockedDescription:
      "Your business account has been blocked. Please contact the administrator for more information.",
    contactAdmin: "Contact Admin",
  },
  validation: {
    required: "Required field",
    minLength: "Minimum {{min}} characters",
    maxLength: "Maximum {{max}} characters",
    invalidPhone: "Invalid phone number",
    invalidEmail: "Invalid email address",
    invalidPrice: "Invalid price",
    minValue: "Minimum value: {{min}}",
    maxValue: "Maximum value: {{max}}",
    fileTooLarge: "File too large (maximum {{max}}MB)",
    invalidFileType: "Unsupported file type",
  },
  appPreview: {
    title: "App Preview",
    description: "This is how customers see your business in the BiDi app",
    openPreview: "App Preview",
    editProfile: "Edit Profile",
    editMenu: "Edit Menu",
    searchPlaceholder: "Looking for a specific dish?",
    openNow: "Open Now",
    minimumOrder: "Minimum order",
    minutes: "min",
    noItems: "No items in this category",
  },
  errors: {
    generic: "Something went wrong, please try again",
    network: "Network error, check your internet connection",
    unauthorized: "Unauthorized, please log in again",
    forbidden: "You don't have permission to perform this action",
    notFound: "Page not found",
    serverError: "Server error, please try again later",
  },
};
